@if (canShowPersonTypeToggle) {
  <span class="person-label" [ngClass]="{ 'text-highlight': !isHuman }">Pessoa jurídica</span>
  <div
    id="global-toggle-pf-pj-container"
    class="d-flex flex-nowrap px-2"
    style="background-color: #f9f9f9; border-radius: 8px; gap: 8px"
    >
    <div data-toggle="tooltip" data-placement="left" title="Pessoa jurídica">
      <img [src]="companyIconURL" alt="company" style="max-width: 30px" />
    </div>
    <mat-slide-toggle
      id="global-toggle-pf-pj"
      labelPosition="before"
      [checked]="isHuman"
      [(ngModel)]="isHuman"
      color="primary"
      [disabled]="isPersonTypeToggleDisabled"
      (change)="handlePersonTypeToggleChange()"
      >
    </mat-slide-toggle>
    <div data-toggle="tooltip" data-placement="left" title="Pessoa física">
      <img [src]="humanIconURL" alt="individuos" style="max-width: 30px" />
    </div>
  </div>
  <span class="person-label" [ngClass]="{ 'text-highlight': isHuman }">Pessoa física</span>
}
